import type { RouteLocationNormalizedLoaded } from 'vue-router'

/**
 * Stable key for top-level router-view so nested tenant tabs do not remount the parent layout.
 */
export function resolveRouteViewKey(route: RouteLocationNormalizedLoaded): string {
  const id = route.params.id
  if (id == null || id === '' || String(id) === 'new') {
    return route.fullPath
  }

  if (route.fullPath.includes('/suspended')) {
    return route.fullPath
  }

  const tenantLayout = route.matched.find((record) => record.path === 'tenants/:id')
  if (tenantLayout) {
    return `tenant:${String(id)}`
  }

  if (/^\/app\/tenants\/[^/]+(?:\/.*)?$/.test(route.fullPath)) {
    return `tenant:${String(id)}`
  }

  return route.fullPath
}

/** True when viewing a tenant workspace (any tab under `/app/tenants/:id`). */
export function isTenantDetailRoute(route: RouteLocationNormalizedLoaded): boolean {
  return resolveRouteViewKey(route).startsWith('tenant:')
}

/** Tab switch within the same tenant — skip page-level progress / transitions. */
export function isSameTenantTabNavigation(
  from: RouteLocationNormalizedLoaded,
  to: RouteLocationNormalizedLoaded,
): boolean {
  return (
    isTenantDetailRoute(from) &&
    isTenantDetailRoute(to) &&
    String(from.params.id) === String(to.params.id)
  )
}
